import React from 'react';

export enum AIconSize {
  S = 'S (16x16)',
  M = 'M (20x20)',
  L = 'L (24x24)',
  XL = 'XL (32x32)',
  XXL = 'XXL (40x40)',
  XXXL = 'XXXL (64x64)',
}

export interface AIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: AIconSize;
  icon: string;
}
